import {ReactComponent as XpertKnowledgeLogo} from '../../common/assets/xpert-knowledge-logo.svg'
import {Block, Col, Row} from 'jsxstyle'
import {Outlet, useNavigate} from 'react-router-dom'
import {XpertKnowledgeContextProvider} from '../../views/XpertKnowledge/XpertKnowledgeContext'
import CopilotChatButton from '../../views/Copilot/CopilotChatButton'
import {ReactComponent as DocsIcon} from '../../common/assets/bookmarks-icon.svg'
import {ReactComponent as LogoutIcon} from '../../common/assets/logout-icon.svg'
import {ReactComponent as SettingsIcon} from '../../common/assets/settings-icon.svg'
import {CopilotContextProvider} from '../../views/Copilot/CopilotContext'
import {UserRole} from '../../services/User/type'
import type {ActionItem} from '../../components/ActionsDropdown/ActionsDropdown'
import {Upvoty} from '@upvoty/react'
import {useXpertKnowledgeAuthContext} from '../AuthContext'
import ActionsDropdown from '../ActionsDropdown'
import i18n from '../../common/i18n'

export default function AppXpertKnowledgeContainer() {
  const navigate = useNavigate()
  const {user, logout} = useXpertKnowledgeAuthContext()

  const dropdownActions: ActionItem[] = [
    {
      label: i18n.t('xk.header.dropdown.doc'),
      icon: <DocsIcon height={24} width={24} />,
      onClick: () => {
        window.open('https://support.sightcall.com/hc/en-us/articles/38518839846292-Xpert-Knowledge', '_blank')
      },
    },
    {
      label: i18n.t('xk.header.dropdown.settings'),
      icon: <SettingsIcon height={24} width={24} color="black" style={{marginTop: '3px'}} />,
      onClick: () => {
        navigate('/xpert-knowledge/settings')
      },
      disable: user?.role != UserRole.ADMIN_SIGHTCALL && user?.role != UserRole.ADMIN,
    },
    {
      label: i18n.t('xk.header.dropdown.logout'),
      icon: <LogoutIcon height={24} width={24} color="#b23b3b" style={{marginTop: '3px'}} />,
      onClick: () => {
        logout()
      },
    },
  ]

  return (
    <Col height="100%" width="100%">
      <Col width="100%" height="79px" backgroundColor="#000000" justifyContent="center">
        <Row width="100%" height="100%" alignItems="center" justifyContent="space-between">
          <XpertKnowledgeLogo
            width={291}
            height={22}
            color="white"
            style={{marginLeft: '30px', cursor: 'pointer'}}
            onClick={() => navigate('/xpert-knowledge')}
          />
          {user && (
            <Row gap="20px" paddingRight="20px" alignItems="center">
              <Block fontSize="16px" lineHeight="24px" fontWeight={500} color="#FFFFFF">
                {user.fullName ?? i18n.t('xk.header.userNotFound')} - {user.role ?? i18n.t('xk.header.roleNotFound')}
              </Block>
              <ActionsDropdown actions={dropdownActions} />
            </Row>
          )}
        </Row>
      </Col>
      <Row justifyContent="center" height="100%" width="100%" backgroundColor="#FFFFFF" boxSizing="border-box" overflow="hidden">
        <Col flex="1" height="100%">
          <XpertKnowledgeContextProvider>
            <Outlet />
          </XpertKnowledgeContextProvider>
        </Col>
      </Row>
      {window.location.pathname !== '/xpert-knowledge/error' &&
        window.location.origin !== 'https://ai-portal.sightcall.com' &&
        window.location.origin !== 'https://ai-portal-us.sightcall.com' && (
          <CopilotContextProvider>
            <CopilotChatButton />
          </CopilotContextProvider>
        )}
      {(window.location.origin === 'https://ai-portal.sightcall.com' || window.location.origin === 'https://ai-portal-us.sightcall.com') && (
        <Upvoty projectId="85f1fd98-04e1-468f-b5ce-84e331e1e462" />
      )}
    </Col>
  )
}
